import { Box, useTheme } from '@mui/material';
import { keyframes } from '@mui/material/styles';
import { FC } from 'react';

const pulseAnimation = keyframes`
  0% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 var(--pulse-shadow-color);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 var(--pulse-shadow-size) var(--pulse-shadow-color-transparent);
  }
  100% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 var(--pulse-shadow-color-transparent);
  }
`;

interface PulseIndicatorProps {
  color?: string;
  'data-testid'?: string;
  size?: number;
  speed?: number;
}

export const PulseIndicator: FC<PulseIndicatorProps> = ({
  color,
  size = 16,
  speed = 2000,
  ...props
}) => {
  const theme = useTheme();
  const pulseColor = color ?? theme.palette.success.light;
  const pulseShadowSize = Math.round(size * 0.625);

  return (
    <Box
      data-testid={props['data-testid']}
      sx={{
        '--pulse-shadow-color': pulseColor,
        '--pulse-shadow-color-transparent': `${pulseColor}00`,
        '--pulse-shadow-size': `${pulseShadowSize}px`,
        animation: `${pulseAnimation} ${speed}ms infinite`,
        backgroundColor: pulseColor,
        borderRadius: '50%',
        boxShadow: '0 0 0 0 var(--pulse-shadow-color)',
        height: `${size}px`,
        width: `${size}px`,
      }}
    />
  );
};
